import { Card, Icon, List, SimpleTooltip } from 'corso-admin-ui';
import { ReactNode } from 'react';

export function CorsoAIBadge() {
  return (
    <span className="ai-shimmer-on-hover inline-flex ai-shimmer cursor-default items-center gap-1 rounded-md px-1.5 py-1.5 text-[10px] leading-none font-bold tracking-wider text-white uppercase shadow-xs ring-1 ring-white/20 drop-shadow-[0_1px_1px_rgba(99,102,241,0.25)] ring-inset">
      <Icon icon="ai" className="size-3" />
      Corso AI
    </span>
  );
}

export function CorsoAIBadgeTooltip({ message }: { message: string }) {
  return (
    <SimpleTooltip content={message}>
      <CorsoAIBadge />
    </SimpleTooltip>
  );
}

/**
 * Reusable card for AI-powered feature settings.
 * Uses a shimmer top-accent and sparkles icon to visually distinguish AI features.
 */
export function AIFeatureCard({
  id,
  title,
  description,
  action,
  features,
}: {
  id?: string;
  title: string;
  description: string;
  /** Optional action control rendered at the right of the header, such as a switch or button. */
  action?: ReactNode;
  /** Optional list of feature bullet points to display in a two-column grid. */
  features?: string[];
}) {
  return (
    <div id={id} className="relative overflow-hidden rounded-lg">
      <div className="absolute inset-x-0 top-0 h-1 ai-shimmer" />
      <Card>
        <Card.Line as="header">
          <div className="flex items-center gap-3">
            <div className="flex shrink-0 items-center justify-center rounded-lg p-2.5 ai-gradient">
              <Icon icon="ai" className="size-5 text-white" />
            </div>
            <Card.Heading as="h3">{title}</Card.Heading>
            {action}
          </div>
          <CorsoAIBadge />
        </Card.Line>

        <Card.Description>{description}</Card.Description>

        <List items={features ?? []} columns={2}>
          {(feature) => <List.Item key={feature}>{feature}</List.Item>}
        </List>
      </Card>
    </div>
  );
}
